// jQuery(function($){
//     $.datepicker.regional['ru'] = {
//         closeText: 'Закрыть',
//         prevText: '&#x3C;Пред',
//         nextText: 'След&#x3E;',
//         currentText: 'Сегодня',
//         monthNames: ['Январь','Февраль','Март','Апрель','Май','Июнь',
//         'Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
//         monthNamesShort: ['Янв','Фев','Мар','Апр','Май','Июн',
//         'Июл','Авг','Сен','Окт','Ноя','Дек'],
//         dayNames: ['воскресенье','понедельник','вторник','среда','четверг','пятница','суббота'],
//         dayNamesShort: ['вск','пнд','втр','срд','чтв','птн','сбт'],
//         dayNamesMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
//         weekHeader: 'Нед',
//         dateFormat: 'dd.mm.yy',
//         firstDay: 1,
//         isRTL: false,
//         showMonthAfterYear: false,
//         yearSuffix: ''
//     };
//     $.datepicker.setDefaults($.datepicker.regional['ru']);
//
//     var inp_files = $('.ajax_claim input[type="file"]');
//        $('.ajax_claim input[type="file"]').hide();
//        inp_files.each(function(ind, el){
//            $(el).closest('.field_line').append('<div class="file_box"><span class="file_name">Файл не выбран</span><span class="for_file">Выберите файл</span> </div>');
//        });
// });
function incube_ajax(block,data_type, action, params, success_func, error_func) {
    $.ajax({
        type: "POST",
        url: '/ajax.php?block='+block+'&action='+action+'&data_type='+data_type,
        data: params,
        dataType: data_type,
        success: success_func,
        error: error_func       
    });
}
function incube_file_ajax(block,data_type, action, params, success_func, error_func) {
    $.ajax({
        type: "POST",
        url: '/ajax.php?block='+block+'&action='+action+'&data_type='+data_type,
        data: params,
        dataType: data_type,
        processData: false,
        contentType: false,
        success: success_func,
        error: error_func       
    });
}

$(document).on('submit',".voting_form", function(e){
    e.preventDefault();
    incube_ajax('voting','json', 'send_form', $(this).serializeArray(), votingform);
});
    
function votingform(data){
    if(data.err){
       $('#voting_block_'+data.voting_id+ ' .var_answers').append('<div class="voting_err">Выберите ответ</div>'); 
    }else{
       $('#voting_block_'+data.voting_id).html(data.html); 
    }
}    
   

function check_empty_form_val(){
    if($('#val_from_price').val() == ''){
        $('#val_from_price').prop("disabled",true);
    }
    if($('#val_to_price').val() == ''){
        $('#val_to_price').prop("disabled",true);
    }
    $('#filterCatalogForm select').each(function(ind, el){
        if($(el).val() == '0'){
            $(el).prop("disabled",true);
        }
    });
    $('#filterCatalogForm input[type="text"]').each(function(ind, el){
        if($(el).val() == ''){
            $(el).prop("disabled",true);
        }
    });
}

function create_map(wrap_id, x, y, text) {
    ymaps.ready(function() {
        var myMap = new ymaps.Map(wrap_id, {
            center: [x, y],
            zoom: 16,
            controls: []
        });
        myMap.behaviors.disable('scrollZoom');
        var myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
            balloonContentBody: [
                '<address>',
                text,
                '</address>'
            ].join('')
        }, {
            preset: 'islands#redDotIcon'
        });
        myMap.geoObjects.add(myPlacemark);
    });
}

$(window).scroll(function() {
    var header_height = $('.page-header').innerHeight() + 10;
    if ($(window).scrollTop() >= header_height) {
        $('.fixed_header').addClass('active');
    } else {
        if ($('.fixed_header').hasClass('active')) {
            $('.sr_box').eq(1).empty().hide();
            $('.search_wrap .search').eq(1).val('');
        }
        $('.fixed_header').removeClass('active');
    }
});